export default "__VITE_ASSET__BnLIi0ow__"